import React from 'react';
import { setInstanceConfigurations } from '../../services/AppInit';
import fetchConfig from '../../hoc/fetchConfig';
import NoServiceView from '../NoServiceView/NoServiceView';

async function fetchConfigFunction() {
  await setInstanceConfigurations();
}

class ConfigComponent extends React.Component {
  render() {
    return this.props.children;
  }
}

export default fetchConfig(fetchConfigFunction, NoServiceView)(ConfigComponent);
